<dc-page-header-wave
  [title]="'Contacto'"
  [subtitle]="
    'Rellene el formulario y nos pondremos en contacto con usted lo antes posible.'
  "
  [containerClass]="'pb-9'"
>
</dc-page-header-wave>

<dc-contacto-form></dc-contacto-form>
<dc-contacto-other-channels></dc-contacto-other-channels>

<dc-footer1></dc-footer1>
